module.exports = __webpack_public_path__ + "t_workstyle_concierge-1.png?3b94476c1c56f5ae7a0eaa9050e3f27d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/t_workstyle_concierge-1.png
// module id = 843
// module chunks = 0